import React from 'react'
import { Typography } from '@mui/material'
import { commify, formatUnits } from 'ethers/lib/utils'
import { UseContractReadConfig, erc20ABI, useContractReads } from 'wagmi'
import { BigNumber } from 'ethers'
import { SupportedTicker, TICKERS_MAP_BY_NAME } from '@/constants/token'
import { shouldUseValutContract } from '@/utils'
import { getVaultContractAddress } from '@/utils/contract'

const getContractReadConfig = (tickerName: SupportedTicker, chainId: number): UseContractReadConfig => {
  if (shouldUseValutContract(tickerName)) {
    return {
      address: TICKERS_MAP_BY_NAME[tickerName].erc20Tokens[chainId].address,
      args: [getVaultContractAddress(chainId)],
      chainId,
      abi: erc20ABI,
      functionName: 'balanceOf',
    }
  } else {
    return {
      address: TICKERS_MAP_BY_NAME[tickerName].erc20Tokens[chainId].address,
      chainId: chainId,
      abi: erc20ABI,
      functionName: 'totalSupply',
    }
  }
}

export const ExistingCrossChainAmount = ({ tickerName }: { tickerName: SupportedTicker }) => {
  const defaultDecimal =
    TICKERS_MAP_BY_NAME[tickerName].erc20Tokens[TICKERS_MAP_BY_NAME[tickerName].supportChains[0]].decimal

  const configs = TICKERS_MAP_BY_NAME[tickerName].supportChains.map((chainId) => {
    return getContractReadConfig(tickerName, chainId)
  })

  const { data } = useContractReads({
    contracts: configs,
  })

  const amount =
    data
      ?.filter((reuslt) => reuslt.status === 'success')
      .map((item) => BigNumber.from(item.result || 0))
      .reduce((previousValue, currentValue) => {
        return previousValue.add(currentValue)
      }, BigNumber.from(0))
      .toString() || '0'

  // console.log('>>>>>>>', tickerName, data, amount)

  // return null
  return (
    <Typography sx={{ fontSize: { xs: '14px', md: '16px' }, fontWeight: { xs: 400, md: 700 } }}>
      {commify(Number(formatUnits(amount, defaultDecimal)).toFixed(2))} {tickerName}
    </Typography>
  )
}
